import React from "react";
import { Form, Row } from "react-bootstrap";

import { getExtraProductDetailsByCode, getMainProductDetails, parseBooleanValueView } from "_helpers";
import FormPDF from "components/OrderDetails/ProductDetails/FormPDF";

import StatusView from "../Status/View";
import { LLC_INCORPORATION_CODES } from "variables/Variables";

function FormAnnualReport({ parentOrderDetails, orderDetails, selectedProduct, onUpdateOrderStatus, onChange }) {
  const productDetails = orderDetails?.products[selectedProduct];
  const { mainProductDetails } = getMainProductDetails(orderDetails, parentOrderDetails);
  const { extraProductDetails } = getExtraProductDetailsByCode(
    orderDetails,
    parentOrderDetails,
    LLC_INCORPORATION_CODES
  );
  const llcState = extraProductDetails?.organizedState;

  return (
    <div className="form-border">
      <h4 className="m-0 font-weight-bold mb-2">Annual Report</h4>

      <StatusView
        orderDetails={orderDetails}
        selectedProduct={selectedProduct}
        onUpdateOrderStatus={onUpdateOrderStatus}
        onChange={onChange}
      />

      {productDetails.webFileNumber !== undefined && (
        <Form.Group as={Row}>
          <Form.Label column sm={5}>
            Webfile Number:
          </Form.Label>
          <Form.Label column sm={7}>
            {productDetails?.webFileNumber || "—"}
          </Form.Label>
        </Form.Group>
      )}

      <hr />
      <Form.Group as={Row}>
        <Form.Label column sm={5}>
          Social Security Number:
        </Form.Label>
        <Form.Label column sm={7}>
          {mainProductDetails?.owner?.ssn || productDetails?.ssn || "N/A"}
        </Form.Label>
      </Form.Group>

      <FormPDF productDetails={productDetails} />

      {llcState === "MD" && (
        <>
          <hr />
          <h6 className="font-weight-bold">Maryland Annual Report Questions</h6>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Does business own, lease, or use personal property, located in Maryland with a total original cost of
              $20,000 or more?
            </Form.Label>
            <Form.Label column sm={7}>
              {parseBooleanValueView(productDetails?.marylandAnnualQuestions?.usePersonalProperty)}
            </Form.Label>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Did the business have more than one physical location in Maryland for the year being filed?
            </Form.Label>
            <Form.Label column sm={7}>
              {parseBooleanValueView(productDetails?.marylandAnnualQuestions?.moreThanOnePhysicalLocation)}
            </Form.Label>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Has the location of the property changed from last year’s return?
            </Form.Label>
            <Form.Label column sm={7}>
              {parseBooleanValueView(productDetails?.marylandAnnualQuestions?.locationHasChanged)}
            </Form.Label>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Is the property located inside the limits of an incorporated town?
            </Form.Label>
            <Form.Label column sm={7}>
              {parseBooleanValueView(productDetails?.marylandAnnualQuestions?.locatedInsideIncorporatedTown)}
            </Form.Label>
          </Form.Group>
        </>
      )}
    </div>
  );
}

export default FormAnnualReport;
